module.exports = __webpack_public_path__ + "assets/img/picture2.5ad6b187.svg";